import React, { FC } from 'react';
import classNames from 'classnames';

import { Icon, sounds } from '@whitesharx/starfall-frontend-ui-kit';

import { closeButtonStyles, iconStyles, CLOSE_BUTTON_CLASS } from './styles.css';

type ModalCloseButtonProps = {
  className?: string;
  onClick: () => void;
};

const playSound = () => sounds.play('click');

const ModalCloseButton: FC<ModalCloseButtonProps> = ({ onClick, className }) => (
  <button
    className={classNames(closeButtonStyles, CLOSE_BUTTON_CLASS, className)}
    onClick={() => {
      playSound();
      onClick();
    }}
  >
    <Icon name="close" size="14px" className={iconStyles} />
  </button>
);

export default ModalCloseButton;
